import { GLOBAL_ERROR_DISMISS } from '../../actions/constants/types';
import { globalErrorList, perErrorConfiguration, defaultConfig } from '../../settings/errorSettings';

const initialState = {
  lastError: {
    errorShown: true,
  },
};

function errorsReducer(state = initialState, action) {
  if (globalErrorList.includes(action.type)) {
    const specificConfig = perErrorConfiguration[action.type] || {};
    const errorConfig = { ...defaultConfig, ...specificConfig };
    const { message, status } = action;
    return {
      lastError: {
        message,
        status,
        timeStamp: Date.now().toString(),
        ...errorConfig,
        errorShown: false,
      },
    };
  } else if (action.type === GLOBAL_ERROR_DISMISS) {
    return {
      // Leave the error data so it doesn't change what's animated in the snackbar
      lastError: {
        ...state.lastError,
        errorShown: true,
      },
    };
  }
  return state;
}

export default errorsReducer;
